if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
            StampedFn.reloadUGC();
            loyaltylion.ui.refresh();
            if(this.productElement.querySelector('.rc-widget-wrapper form')){
              var prod_id = this.productElement.querySelector('.rc-widget-wrapper form [name="product-id"]');
              window.ReChargeWidget?.createWidget({ productId: prod_id });
            }
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        
        if(element.querySelector('.pdp-short-descrption')){
          element.querySelector('.guaranteed-text-main').parentNode.insertBefore(element.querySelector('.pdp-short-descrption'), element.querySelector('.guaranteed-text-main').nextSibling);
        }

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        let gallerySwiper = element.querySelector('.product__media-wrapper [data-gallery-slider]');
        let slideEffect = 'fade';
        let breakPoints = window.matchMedia('(max-width: 750px)');

        if (breakPoints.matches) {
          slideEffect = 'fade';
          gallerySwiper = element.querySelector('[data-gallery-slider]'); // slider is default for mobile screen
        }
        
        if (gallerySwiper) {
          console.log(gallerySwiper,'gallerySwiper');
          let gallerySwiperInit = new Swiper(gallerySwiper, {
            effect: slideEffect,
            loop: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.product__holder-pagination',
            },
            on: {
              transitionStart: function () {
                const allVideos = [
                  ...document.querySelectorAll('[data-gallery-slider] video, [data-gallery-slider] iframe'),
                ];
                if (allVideos.length) window.pauseAllMedia();
              },

              transitionEnd: function () {
                const activeIndex = this.activeIndex;
                const activeSlide = document.querySelectorAll('[data-gallery-slider] .swiper-slide')[activeIndex];
                const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
                if (activeSlideVideo) activeSlideVideo.play();
                //for external video
                const activeSlideIframe = activeSlide.getElementsByTagName('iframe')[0];
                if (activeSlideIframe) {
                  let iframeSrc = activeSlideIframe.getAttribute('src');
                  if (iframeSrc.includes('?autoplay=0')) {
                    let newSrc = iframeSrc.replace('?autoplay=0', '?autoplay=1&muted=1');
                    activeSlideIframe.setAttribute('src', newSrc);
                  }
                  if (iframeSrc.includes('vimeo.com')) {
                    activeSlideIframe.contentWindow.postMessage('{"method":"play"}', '*');
                  } else {
                    activeSlideIframe.contentWindow.postMessage(
                      '{"event":"command","func":"' + 'playVideo' + '","args":""}',
                      '*'
                    );
                  }
                }
              },
            },
          });
        }
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
